import React, { useState } from "react";
import "./FloorPlanSection.css";
import groundFloorPlan from "../../assets/ground-floor-plan.png";
import firstFloorPlan from "../../assets/first-floor-plan.png";
import secondFloorPlan from "../../assets/second-floor-plan.png";

const FloorPlanSection = () => {
  const [activeFloor, setActiveFloor] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState("");

  const floorPlans = [
    {
      id: "ground",
      title: "Ground Floor",
      subtitle: "251 Sq.yd.",
      image: groundFloorPlan,
      features: [
        "2 Car Parking Spaces",
        "Spacious Living Room",
        "Modular Kitchen",
        "Master Bedroom with Attached Bath",
        "Guest Bedroom",
        "Common Bathroom",
        "Storage Area",
        "Landscaped Garden Area",
      ],
      area: "1323 + 1168 Sq.Ft.",
      type: "Ground Floor + Basement",
    },
    {
      id: "first",
      title: "First Floor",
      subtitle: "251 sq.yd.",
      image: firstFloorPlan,
      features: [
        "Large Living & Dining Area",
        "Modern Modular Kitchen",
        "Master Bedroom with Walk-in Closet",
        "2 Additional Bedrooms",
        "2 Full Bathrooms",
        "Balcony Access",
        "Study/Work Area",
        "Ample Natural Light",
      ],
      area: "1394 Sq.Ft.",
      type: "First Floor",
    },
    {
      id: "second",
      title: "Second Floor",
      subtitle: "251 sq.yd.",
      image: secondFloorPlan,
      features: [
        "Open Plan Living Area",
        "Premium Kitchen with Island",
        "Master Suite with En-suite",
        "2 Bedrooms with Built-in Storage",
        "2 Modern Bathrooms",
        "Private Terrace Access",
        "Utility/Laundry Area",
        "Panoramic Views",
      ],
      area: "1394 + 678 Sq.Ft.",
      type: "Second Floor + Terraces",
    },
  ];

  const handleFloorChange = (index) => {
    setActiveFloor(index);
  };

  const openLightbox = (image) => {
    setLightboxImage(image);
    setLightboxOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage("");
    document.body.style.overflow = "unset";
  };

  const currentFloor = floorPlans[activeFloor];

  return (
    <section className="floor-plan-section" id="floor-plan">
      <div className="container">
        <div className="floor-plan-layout">
          {/* Left Content */}
          <div className="floor-plan-content">
            <div className="floor-plan-header">
              <h2 className="floor-plan-title">
                Ansal Esencia <span className="highlight">Floor Plan</span>
              </h2>
            </div>

            {/* Floor Navigation Tabs */}
            <div className="floor-tabs">
              {floorPlans.map((floor, index) => (
                <button
                  key={floor.id}
                  className={`floor-tab ${
                    activeFloor === index ? "active" : ""
                  }`}
                  onClick={() => handleFloorChange(index)}
                >
                  <span className="tab-title">{floor.title}</span>
                  <span className="tab-subtitle">{floor.subtitle}</span>
                </button>
              ))}
            </div>

            {/* Active Floor Plan */}
            <div className="floor-plan-display">
              <div className="floor-plan-image-container">
                <img
                  src={currentFloor.image}
                  alt={`${currentFloor.title} Plan`}
                  className="floor-plan-image"
                  loading="lazy"
                  decoding="async"
                  onClick={() => openLightbox(currentFloor.image)}
                />
                <div className="image-overlay">
                  <button
                    className="btn btn--outline btn--sm zoom-button"
                    onClick={() => openLightbox(currentFloor.image)}
                    aria-label="Click to view full size"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <circle cx="11" cy="11" r="8" />
                      <path d="m21 21-4.35-4.35" />
                      <line x1="11" y1="8" x2="11" y2="14" />
                      <line x1="8" y1="11" x2="14" y2="11" />
                    </svg>
                    View Full Size
                  </button>
                </div>
              </div>

              <div className="floor-plan-info">
                <h3 className="floor-info-title">
                  Ansal Esencia 3 BHK {currentFloor.title} ({currentFloor.area})
                </h3>

                <div className="floor-details">
                  <div className="detail-item">
                    <span className="detail-label">Floor Type:</span>
                    <span className="detail-value">{currentFloor.type}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Total Area:</span>
                    <span className="detail-value">{currentFloor.area}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Plot Size:</span>
                    <span className="detail-value">251 Square Yards</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-container">
            <button className="lightbox-close" onClick={closeLightbox}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
            <img
              src={lightboxImage}
              alt="Floor Plan Full Size"
              className="lightbox-image"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default FloorPlanSection;
